/**
 * 全局状态
 */
const global = {
    namespaced: true,
    state: {
        //  导航数据
        navInfos: [],
        //  搜索结果
        searchResult: [],
        SearchTypeSelect: "all",
        // TypeSelect: "all",
        TypeSelect: "all",
        SizeSelect: "all",
        // filterTypeItems: [
        //     { text: "不限类型", value: "all" },
        //     { text: "仅图片", value: "image" },
        //     { text: "仅视频", value: "video" },
        // ],
        churchLifeModel: 0,
        pages: 1,

        //  一级库的id
        driveIdsID: [],
        //  二级菜单ID
        lv1_ID: [],
        //  三级菜单ID []
        lv2_ID: [],
        //  筛选类型 格式
        formatType: "all",
        //  开始时间
        starTime: "",
        //  结束时间
        endTime: "",
        //  搜索关键字
        keyword: "",
        //  排序类型
        sequenceType: "",
        //  最小下载量
        download_start: 0,
        //  最大下载量
        download_end: 9_9999,

        allCardList: [],
        allCardListMeta: {},
        isListLoading: false,

        //  第一次加载数据结束
        firstLoadingDone: false,
        transitionName: "fade",
        //是否有显示tag标签的权限
        capabilities: false,
        isAjaxPush: true,
        isHomeAjax: true,
        mainMenuInfoOne: "",
        isShowDownLoad: true,
        cardId: -1,
        lv1ActiveItem: 0
    },
    action: {},
    mutations: {
        // 更新导航数据
        updateNavInfos(state, navInfos) {
            state.navInfos = navInfos;
        },
        // 更新页码
        updatePages(state, pages) {
            state.pages = pages;
        },
        // 更新教会生活类型
        updateChurchLifeModel(state, churchLifeModel) {
            state.churchLifeModel = churchLifeModel;
        },
        // 更新尺寸类型
        updateSizeSelect(state, SizeSelect) {
            state.SizeSelect = SizeSelect;
        },
        // 更新筛选类型
        updateTypeSelect(state, TypeSelect) {
            state.TypeSelect = TypeSelect;
        },
        // 更新搜索筛选类型
        updateSearchTypeSelect(state, SearchTypeSelect) {
            state.SearchTypeSelect = SearchTypeSelect;
            // state.TypeSelect = SearchTypeSelect;
        },
        // 更新搜索结果
        updateSearchResult(state, searchResult) {
            state.searchResult = searchResult;
        },
        // 更新一级库的分类
        updateDriveIdsID(state, driveIdsID) {
            // console.log(driveIdsID);
            state.driveIdsID = driveIdsID;
        },
        // 更新二级菜单的分类
        updateLv1_ID(state, lv1_ID) {
            // console.log(lv1_ID);
            state.lv1_ID = lv1_ID;
        },
        // 更新三级菜单的分类
        updateLv2_ID(state, lv2_ID) {
            state.lv2_ID = lv2_ID;
        },

        //  更新开始时间
        updateStarTime(state, sTime) {
            state.starTime = sTime;
        },
        //  更新结束时间
        updateEndTime(state, eTime) {
            state.endTime = eTime;
        },
        // 更新搜索关键字
        updateKeyword(state, keyword) {
            state.keyword = keyword;
        },
        updateDownloadStart(state,val){
            state.download_start = val
        },
        updateDownloadEnd(state,val){
            state.download_end = val
        },
        // 更新排序类型
        updateSequenceType(state, sequenceType) {
            state.sequenceType = sequenceType;
        },

        updateFirstLoadingDone(state) {
            state.firstLoadingDone = !state.firstLoadingDone;
        },
        updateTransitionName(state, name) {
            state.transitionName = name;
        },
        updateCapabilities(state, isShow) {
            state.capabilities = isShow;
        },
        updateIsAjaxPush(state) {
            state.isAjaxPush = !state.isAjaxPush;
        },
        updateIsHomeAjax(state) {
            state.isHomeAjax = !state.isHomeAjax;
        },
        updateMainMenuInfoOne(state) {
            state.mainMenuInfoOne = state.slug;
        },
        updateIsShowDownLoad(state, isShow) {
            state.isShowDownLoad = isShow;
        },
        updateCardId(state, nub) {
            state.cardId = nub;
        },
        updateAllCardList(state, newData) {
            state.allCardList = newData;
        },
        updateAllCardListMeta(state, newData) {
            // console.log(this.allCardListMeta);
            state.allCardListMeta = newData;
        },
        updateIsListLoading(state, isLoading) {
            state.isListLoading = isLoading;
        },
        updateChangeLv1ActiveItem(state, newData) {
            state.lv1ActiveItem = newData;
        }
    }
};

export default global;
